import { Grid, Typography } from "@deere/fuel-react";
import LinearProgress from "@mui/material/LinearProgress";

const SelfServiceLoader = ({ loader }) => {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      minHeight={"60vh"}
      rowSpacing={2}
    >
      <Grid item alignSelf="center">
        <Typography variant="h2">{loader.message}</Typography>
      </Grid>
      {loader.isLoading && (
        <Grid item alignSelf="center" width={"100%"}>
          <LinearProgress />
        </Grid>
      )}
    </Grid>
  );
};

export default SelfServiceLoader;
